import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// 导入所有语言文件
import en from './locales/en.json';
import zh from './locales/zh.json';
import ja from './locales/ja.json';
import fr from './locales/fr.json';
import de from './locales/de.json';
import pt from './locales/pt.json';
import ru from './locales/ru.json';
import ko from './locales/ko.json';
import ar from './locales/ar.json';

export const resources = {
  en: {
    translation: en
  },
  zh: {
    translation: zh
  },
  ja: {
    translation: ja
  },
  fr: {
    translation: fr
  },
  de: {
    translation: de
  },
  pt: {
    translation: pt
  },
  ru: {
    translation: ru
  },
  ko: {
    translation: ko
  },
  ar: {
    translation: ar
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n; 